import { SyncActionRef } from '../models/sync-action-ref';

// The store key of a synced node — `${type}:${id}` — used both to key the slice and to group
// children by parent. One implementation so storage and grouping can never drift apart.
export const toRefKey = ({ type, id }: SyncActionRef): string => `${type}:${id}`;
